import { RootState } from "../..";

export const selectList = (state: RootState) => state.logs.data.list;

export const selectListPagination = (state: RootState) =>
  state.logs.pagination.list;

export const selectIsListLoading = (state: RootState) =>
  state.logs.loading.list;
